<template>
  <dd-validation-rules-wrapper :name="name" :rules="rules">
    <template #default="validationWrapperProps">
      <validation-provider ref="provider" :name="name" :rules="validationWrapperProps.rules" v-slot="validationProps">
        <dd-input-wrapper
            :rules="validationWrapperProps.rules"
            :title="title"
            :errors="validationProps.errors"
            :name="name"
            :value="value"
            :provider-ref="$refs.provider"
            v-slot="{validateInput}"
        >
            <div class="flex-row gap-xs align-items-center">
                <input
                  :id="name"
                  :name="name"
                  type="checkbox"
                  :data-dusk="dataDusk"
                  @change="(e) => {validateInput(e.target.checked); $emit('input', e.target.checked)}"
                  :value="value"
                  v-bind="$attrs"
                  style="margin: 0"
                />
                <label :for="name" class="color-black">{{label}}</label>
            </div>
        </dd-input-wrapper>
      </validation-provider>
    </template>
    </dd-validation-rules-wrapper>
</template>

<script>
export default {
  name: "DdCheckbox",
  emits: ['input'],
  props: {
    dataDusk: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: false
    },
    label: {
      type: String,
      required: false
    },
    name:  {
      type: String,
      required: false,
      default: () => Math.floor(Math.random() * 1000000000).toString(),
    },
    value:  {
      type: [String, Number, Boolean],
      required: false
    },
    rules: {
      type: [Array, String],
      required: false
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>
